'use client'

import { useMutation } from '@apollo/client'
import { useEffect } from 'react'

import {
  UpdateUserPreferenceDocument,
  UpdateUserPreferenceMutation,
  UpdateUserPreferenceMutationVariables
} from '@/gql/graphql'
import { localToken } from '@/service/token'

function PreferenceUpdater() {
  const [updateUserPreference] = useMutation<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>(UpdateUserPreferenceDocument, {
    variables: {
      input: {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timezoneOffset: new Date().getTimezoneOffset(),
      }
    },
  })

  useEffect(() => {
    if (!localToken) {
      return
    }
    updateUserPreference()
  }, [])

  return null
}

export default PreferenceUpdater